import baseUrl from './baseUrl';

const URL_CRIAR_CHAMADO = `${baseUrl}/chamado`;

const criarChamado = async data => {
  try {
    const response = await fetch(URL_CRIAR_CHAMADO, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));

      throw new Error(data.error || 'Ocorreu um erro inesperado');
    }
  } catch (error) {
    throw error;
  }
};

export default criarChamado;
